import { render, staticRenderFns } from "./PasoDosRAComponent.vue?vue&type=template&id=3ce81946"
import script from "./PasoDosRAComponent.vue?vue&type=script&lang=js"
export * from "./PasoDosRAComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports